<template>
    <div class="login-container">
        <div class="login-content">
            <div class="login_title">
                <div>Hello!</div>
                <div>欢迎使用秒达</div>
            </div>

            <div class="login-form-v">
                <el-form
                    ref="loginForm"
                    :model="loginForm"
                    :rules="loginRules"
                    class="login-form"
                    auto-complete="on"
                    label-position="left"
                >
                    <div class="title-container">
                        <div>欢迎使用秒达</div>
                        <div>WELCOME</div>
                    </div>

                    <el-form-item prop="username">
                        <span class="svg-container">
                            <!-- <svg-icon icon-class="user" /> -->
                            <img src="@/assets/images/user.png" alt="" />
                        </span>
                        <el-input
                            ref="username"
                            v-model="loginForm.userName"
                            placeholder="请输入账号"
                            name="username"
                            type="text"
                            tabindex="1"
                            auto-complete="on"
                        />
                    </el-form-item>

                    <el-form-item prop="password">
                        <span class="svg-container">
                            <!-- <svg-icon icon-class="password" /> -->
                            <img src="@/assets/images/password.png" alt="" />
                        </span>
                        <el-input
                            :key="passwordType"
                            ref="password"
                            v-model="loginForm.passWord"
                            :type="passwordType"
                            placeholder="请输入密码"
                            name="password"
                            tabindex="2"
                            auto-complete="on"
                            @keyup.enter.native="handleLogin"
                        />
                        <span class="show-pwd" @click="showPwd">
                            <svg-icon
                                :icon-class="
                                    passwordType === 'password'
                                        ? 'eye'
                                        : 'eye-open'
                                "
                            />
                        </span>
                    </el-form-item>

                    <div class="wjmm_v">
                        <div class="wjmm_v_one" @click="jzmmFlag = !jzmmFlag">
                            <div class="wjmm_v_jzw">
                                <i
                                    class="el-icon-check"
                                    v-if="jzmmFlag"
                                    style="color: #0195ff"
                                ></i>
                            </div>
                            记住我
                        </div>
                        <!-- <div>忘记密码?</div> -->
                    </div>

                    <el-button
                        :loading="loading"
                        type="primary"
                        style="
                            width: 100%;
                            margin-top: 35px;
                            background: #0195ff;
                            box-shadow: 0 2px 9px 0 #0195ff33;
                            border-radius: 8px;
                        "
                        @click.native.prevent="handleLogin"
                        >登录</el-button
                    >

                    <div class="zczh_v" @click="dialogFormVisible = true">
                        注册账号
                    </div>
                </el-form>
            </div>
        </div>
        <el-dialog
            title="注册秒达"
            :visible.sync="dialogFormVisible"
            custom-class="payLikeView"
        >
            <el-form
                :model="registerForm"
                :rules="registerRules"
                ref="registerForm"
            >
                <el-form-item prop="userName">
                    <el-input
                        v-model="registerForm.userName"
                        placeholder="请输入用户名"
                        style="width: 100%"
                        ref="userName"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="email">
                    <el-input
                        v-model="registerForm.email"
                        placeholder="请输入电子邮件（非必填）"
                        style="width: 100%"
                        ref="email"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="passWord">
                    <el-input
                        :key="passwordTypes"
                        ref="passWord"
                        v-model="registerForm.passWord"
                        :type="passwordTypes"
                        placeholder="请输入密码"
                        name="password"
                        tabindex="2"
                        auto-complete="on"
                        @keyup.enter.native="registerSub"
                        style="width: 100%"
                    />
                    <span class="show-pwd" @click="showPwds">
                        <svg-icon
                            :icon-class="
                                passwordTypes === 'password'
                                    ? 'eye'
                                    : 'eye-open'
                            "
                        />
                    </span>
                </el-form-item>
                <el-form-item prop="inviteCode">
                    <el-input
                        v-model="registerForm.inviteCode"
                        placeholder="请输入邀请码（非必填）"
                        style="width: 100%"
                        ref="inviteCode"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="xieyi">
                <div class="xieyiDiv" @click="xieyiFlag = !xieyiFlag">
                    <i
                        class="el-icon-check"
                        v-if="xieyiFlag"
                        style="color: #0195ff"
                    ></i>
                </div>
                我已阅读<span>《用户协议》</span>和<span>《隐私协议》</span>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click.native.prevent="registerSub"
                    style="width: 100%"
                    >立即注册</el-button
                >
            </div>
        </el-dialog>
        <!-- <div class="reserved_v">
            Copyright @ 2021-2022 Tencent. All Rights Reserved
        </div> -->
    </div>
</template>

<script>
import { login, register } from '@/api/index.js'
export default {
    name: 'HelloWorld',
    data() {
        return {
            xieyiFlag: false,
            registerForm: {
                userName: '',
                email: '',
                passWord: '',
                inviteCode: ''
            },
            formLabelWidth: '120px',
            dialogFormVisible: false,
            jzmmFlag: false,
            loginForm: {
                userName: '',
                passWord: '',
                loginType: 'PC'
            },
            loginRules: {
                userName: [
                    { required: true, trigger: 'blur', message: '请输入账号' }
                ],
                passWord: [
                    { required: true, trigger: 'blur', message: '请输入密码' }
                ]
            },
            registerRules: {
                userName: [
                    { required: true, trigger: 'blur', message: '请输入用户名' }
                ],
                passWord: [
                    { required: true, trigger: 'blur', message: '请输入密码' }
                ]
            },
            loading: false,
            passwordType: 'password',

            passwordTypes: 'password',
            redirect: undefined
        }
    },
    // watch: {
    //     $route: {
    //         handler: function (route) {
    //             this.redirect = route.query && route.query.redirect
    //         },
    //         immediate: true
    //     }
    // },
    created() {
        // 检查是否有保存的凭据
        const loginForm = JSON.parse(localStorage.getItem('loginForm'))
        console.log(loginForm, '登录账号密码')
        if (loginForm) {
            this.jzmmFlag = true
            this.loginForm = loginForm
        }
    },
    methods: {
        showPwd() {
            if (this.passwordType === 'password') {
                this.passwordType = ''
            } else {
                this.passwordType = 'password'
            }
            this.$nextTick(() => {
                this.$refs.password.focus()
            })
        },
        showPwds() {
            if (this.passwordTypes === 'password') {
                this.passwordTypes = ''
            } else {
                this.passwordTypes = 'password'
            }

            this.$nextTick(() => {
                this.$refs.passWord.focus()
            })
        },

        handleLogin() {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    login(this.loginForm).then((response) => {
                        this.loading = false
                        console.log(response)
                        if (response.code == 0) {
                            if (this.jzmmFlag) {
                                localStorage.setItem(
                                    'loginForm',
                                    JSON.stringify(this.loginForm)
                                )
                            }
                            localStorage.setItem('token', response.token)
                            this.$message({
                                message: '登录成功',
                                type: 'success'
                            })

                            this.$router.replace({ path: '/home' })
                        }
                    })

                    // this.$store
                    //     .dispatch('user/login', this.loginForm)
                    //     .then(() => {
                    //         this.$router.push({ path: this.redirect || '/' })
                    //         this.loading = false
                    //     })
                    //     .catch(() => {
                    //         this.loading = false
                    //     })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        // 注册
        registerSub() {
            this.$refs.registerForm.validate((valid) => {
                if (valid) {
                    if (!this.xieyiFlag) {
                        this.$message.error('请阅读并同意用户协议与隐私协议')

                        return
                    }
                    this.loading = true
                    console.log(this.registerForm)
                    register(this.registerForm).then((response) => {
                        this.loading = false
                        console.log(response)
                        if (response.code == 0) {
                            this.$message({
                                message: '注册成功',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                        }
                    })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        }
    }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #fff;
$light_gray: #fff;
$cursor: #333;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
    .login-container .el-input input {
        color: $cursor;
    }
}

/* reset element-ui css */
.login-container {
    width: 100%;
    // min-width: 1440px;
    height: 789px;
    background-image: url('~@/assets/images/ic_login_bg.png');
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .el-input {
        display: inline-block;
        height: 56px;
        width: 80%;
        // width: 85%;

        input {
            background: transparent;
            border: 0px;
            -webkit-appearance: none;
            border-radius: 0px;
            color: #333;
            height: 56px;
            caret-color: $cursor;

            &:-webkit-autofill {
                box-shadow: 0 0 0px 1000px $bg inset !important;
                -webkit-text-fill-color: $cursor !important;
            }
        }
    }

    .el-form-item {
        border: 1px solid #dcdcdc;
        border-radius: 8px;
        color: #454545;
    }
}
</style>

<style lang="scss" scoped>
$bg: #bbb;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
    min-height: 100%;
    width: 100%;
    background-color: $bg;
    overflow: hidden;

    .login-content {
        width: 100%;
        flex: 1;
        display: flex;

        .login_title {
            display: flex;
            flex-direction: column;
            margin: 170px 0 0 128px;

            div {
                &:nth-child(1) {
                    color: #000000e6;
                    font-size: 48px;
                    font-weight: 700;
                }

                &:nth-child(2) {
                    color: #000000e6;
                    font-size: 48px;
                    font-weight: 700;
                    margin-top: 18px;
                }
            }
        }

        .login-form-v {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .reserved_v {
        color: #00000066;
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 80px;
    }

    .login-form {
        width: 590px;
        height: 599px;
        padding: 52px 70px 30px;
        overflow: hidden;
        border-radius: 23px;
        background: #ffffff;
        box-shadow: 0 2px 60px 0 #007aff1a;
        // margin-top: 99px;
        // margin-left: 285px;
    }

    .tips {
        font-size: 14px;
        color: #fff;
        margin-bottom: 10px;

        span {
            &:first-of-type {
                margin-right: 16px;
            }
        }
    }

    .svg-container {
        padding: 6px 5px 6px 15px;
        color: $dark_gray;
        vertical-align: middle;
        width: 30px;
        display: inline-block;

        img {
            width: 20px;
            height: 20px;
            margin-top: 10px;
        }
    }

    .title-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;

        div {
            &:nth-child(1) {
                color: #000000;
                font-size: 36px;
                font-weight: 600;
                margin-top: 60px;
            }

            &:nth-child(2) {
                color: #00000099;
                font-size: 20px;
                font-weight: 400;
                margin-top: 12px;
            }
        }
    }

    .show-pwd {
        position: absolute;
        right: 10px;
        top: 7px;
        font-size: 16px;
        color: $dark_gray;
        cursor: pointer;
        user-select: none;
    }

    .wjmm_v {
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 24px;
        color: #0195ff;

        font-size: 14px;
        font-weight: 400;
    }
    .wjmm_v_one {
        color: #111827;
        display: flex;
        align-items: center;
        .wjmm_v_jzw {
            width: 20px;
            height: 20px;
            border-radius: 4px;
            opacity: 1;
            border: 1px solid #cbd5e0;
            background: #ffffffe6;
            margin-right: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .wjmm_v > div:nth-child(1) {
        flex: 1;
        display: flex;
        align-items: center;
    }

    .zczh_v {
        width: 100%;
        text-align: center;
        color: #0195ff;
        font-size: 14px;
        font-weight: 400;
        margin-top: 20px;
    }
}
.xieyi {
    display: flex;

    align-items: center;
    color: #00000066;
    font-size: 12px;
    font-weight: 400;
    font-family: 'AlibabaPuHuiTi';
    .xieyiDiv {
        width: 14px;
        height: 14px;
        border-radius: 172px;
        border: 1px solid #00000066;
        margin-right: 8px;

        display: flex;
        align-items: center;

        justify-content: center;
    }
    span {
        color: #0195ff;
    }
}
::v-deep .el-dialog {
    border-radius: 15px !important;
}
// .payLikeView {
//     width: 500px !important;
// }

/* 在全局CSS或组件样式中添加 */
@media screen and (max-width: 768px) {
    /* 移动端样式调整 */
    .login-container {
        width: 100%;
        padding-top: 30px;
        height: auto;

        box-sizing: border-box;

        .login-content {
            display: block;
            width: 100%;

            .login_title {
                display: flex;
                flex-direction: column;
                margin: 0;
                align-items: center;
                div {
                    &:nth-child(1) {
                        color: #000000e6;
                        font-size: 20px;
                        font-weight: 700;
                    }

                    &:nth-child(2) {
                        color: #000000e6;
                        font-size: 20px;
                        font-weight: 700;
                        margin-top: 18px;
                    }
                }
            }
        }
        .login-form {
            width: 90%;
            overflow: hidden;
            border-radius: 23px;
            background: #ffffff;
            box-shadow: 0 2px 60px 0 #007aff1a;
            padding: 20px;
            box-sizing: border-box;
            height: auto;
            margin-top: 20px;
        }
        .title-container {
            div {
                &:nth-child(1) {
                    color: #000000;
                    font-size: 26px;
                    font-weight: 600;
                    margin-top: 10px;
                }

                &:nth-child(2) {
                    color: #00000099;
                    font-size: 10px;
                    font-weight: 400;
                    margin-top: 12px;
                }
            }
        }
    }

    ::v-deep .payLikeView {
        width: 80% !important;
    }
    /* 其他元素样式调整 */
}
</style>
